// extracted by mini-css-extract-plugin
module.exports = {"badge":"MultipleCustomersList_badge__Bjh_G","icon":"MultipleCustomersList_icon__KYGcG","linkList":"MultipleCustomersList_linkList__qBXdO"};